import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import FloatingGetCare from "./FloatingGetCare";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pt-24 md:pt-28 pb-24 md:pb-0">{children}</main>
      <Footer />
      <StickyMobileCTA />
      <FloatingGetCare />
    </div>
  );
}
